import { ChatRegular } from '@fluentui/react-icons'
import { Badge } from '@/components/shadcn/badge'
import { IconEmailOutline } from '@icons/IconEmailOutline'
import { IconCheckMarkOutline } from '@icons/IconCheckMarkOutline'
import { IconCloseOutline } from '@icons/IconCloseOutline'

export const CollaborationChannelCard = ({
  keyValue,
  value,
  hashtags,
  emailsEnabled,
  cardMenu,
}: {
  keyValue: string
  value: string
  hashtags: string[]
  emailsEnabled?: boolean
  cardMenu: React.ReactNode
}) => {
  const icon = (
    <div className="flex h-12 w-12 flex-shrink-0 flex-grow-0 items-center justify-center self-start rounded-full bg-muted p-2 text-foreground/50">
      <ChatRegular fontSize={34} />
    </div>
  )

  const titleDescription = (
    <div className="flex flex-col justify-between gap-1">
      <div className="flex items-center gap-2">
        <div className="text-base font-medium">{keyValue}</div>
        {emailsEnabled !== undefined && (
          <Badge variant="secondary" className="flex h-5 items-center gap-1 px-1.5 text-xs">
            <IconEmailOutline size={12} />
            {emailsEnabled ? <IconCheckMarkOutline size={12} /> : <IconCloseOutline size={12} />}
          </Badge>
        )}
      </div>
      <div className="text-xs font-light">{value}</div>
      {hashtags.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {hashtags.map((tag, index) => (
            <span key={index} className="inline-block rounded-full bg-muted px-2 py-1 text-xs text-foreground/50">
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  )

  return (
    // <div className="grid grid-cols-[1fr_4fr_1fr] gap-2 rounded-lg bg-background p-4 shadow">
    <div className="grid grid-cols-[1fr_4fr_1fr] gap-2 bg-background p-4 shadow">
      {icon}
      {titleDescription}
      {cardMenu}
    </div>
  )
}
